import { render } from "./CalendarEventOfferAddress.vue?vue&type=template&id=2bef421a&scoped=true"
import script from "./CalendarEventOfferAddress.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOfferAddress.vue?vue&type=script&lang=ts"

import "./CalendarEventOfferAddress.vue?vue&type=style&index=0&id=2bef421a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bef421a"

export default script